var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['mdi', ("mdi-" + _vm.name), _vm.iconClass],style:(_vm.iconStyle),attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }